module.exports = __webpack_public_path__ + "img/3_x6.30036b2b.png";